/* Spanish catalog mirroring locale-fr.js. Keys missing here fall back to English. */
window.PlummeI18n.register('es', {
  'common.save': 'Guardar cambios',
  'common.saving': 'Guardando...',
  'common.cancel': 'Cancelar',
  'common.hoursMinutes': '{h} h {m} min',
  'common.delete': 'Eliminar',
  'common.confirmTitle': '¿Estás seguro?',
  'common.continue': 'Continuar',
  'account.view': 'Vista de cuentas',
  'account.relevant': 'Relevantes',
  'account.all': 'Todas',
  'account.favorites': 'Favoritas',
  'account.addFavorite': 'Añadir a favoritas',
  'account.removeFavorite': 'Quitar de favoritas',
  'account.searchHint': 'Busca por nombre, número o, por ejemplo, 5x',
  'common.working': 'Procesando...',
  'common.close': 'Cerrar',
  'common.on': 'Activado',
  'common.off': 'Desactivado',
  'common.active': 'Activo',
  'common.yes': 'Sí',
  'common.no': 'No',
  'month.short.1': 'Ene',
  'month.short.2': 'Feb',
  'month.short.3': 'Mar',
  'month.short.4': 'Abr',
  'month.short.5': 'May',
  'month.short.6': 'Jun',
  'month.short.7': 'Jul',
  'month.short.8': 'Ago',
  'month.short.9': 'Sep',
  'month.short.10': 'Oct',
  'month.short.11': 'Nov',
  'month.short.12': 'Dic',
  'ui.summary.title': 'Resumen',
  'ui.summary.exVat': 'Total sin IVA',
  'ui.summary.vat': 'IVA',
  'ui.summary.total': 'Total',
  'ui.more': 'Más',
  'ui.filter': 'Filtro',
  'ui.filterReset': 'Borrar filtro',
  'ui.filterChoices': 'Filtros',
  'ui.period': 'Periodo',
  'ui.from': 'Desde',
  'ui.to': 'Hasta',
  'ui.fromMonth': 'Desde el mes',
  'ui.toMonth': 'Hasta el mes',
  'ui.fromDate': 'Fecha de inicio',
  'ui.toDate': 'Fecha de fin',
  'ui.today': 'Hoy',
  'ui.wholeYearTitle': 'Todo {year}',
  'ui.quick.wholeYear': 'Todo el año',
  'ui.quick.ytd': 'Del año hasta hoy',
  'ui.quick.thisTerm': 'Este periodo',
  'ui.quick.lastYear': 'Año anterior',
  'ui.term': 'Periodo {n}',
  'ui.amountSearch': 'Buscar por importe',
  'ui.amountFrom': 'Importe desde',
  'ui.amountTo': 'Importe hasta',
  'list.search': 'Buscar',
  'list.copy': 'Copiar',
  'list.copied': 'Copiado: {text}',
  'list.export': 'Exportar',
  'list.download': 'Descargar',
  'list.downloaded': '{label} descargado',
  'list.nothingToExport': 'No hay filas para exportar',
  'list.downloading': 'Descargando {label} …',
  'list.upload': 'Subir',
  'list.add': 'Añadir',
  'list.archiveTitle': '¿Mover al archivo?',
  'list.archiveConfirm': 'Mover al archivo',
  'list.deleteTitle': '¿Eliminar?',
  'list.delete': 'Eliminar',
  'list.archiveBody': '¿Quieres mover {name} al archivo? El cliente se ocultará de las listas de clientes activos, pero se conservarán las facturas, los pagos y el historial. Esta acción no se puede deshacer desde aquí.',
  'list.deleteBody': '¿Seguro que quieres eliminar {name}? Esta acción no se puede deshacer.',
  'crm.prospect': 'Posible cliente',
  'crm.active': 'Activo',
  'crm.quoteSent': 'Presupuesto enviado',
  'crm.pause': 'En pausa',
  'badge.paid': 'Liquidada',
  'badge.active': 'Activo',
  'badge.sent': 'Enviada',
  'badge.draft': 'Borrador',
  'badge.created': 'Sin enviar',
  'badge.overdue': 'Vencida',
  'badge.credited': 'Abonada',
  'badge.inactive': 'Inactivo',
  'badge.ok': 'Presentada',
  'badge.no': 'No presentada',
  'badge.soon': 'Vence pronto',
  'status.draft': 'Borrador',
  'status.created': 'Sin enviar',
  'status.sent': 'Enviada',
  'status.paid': 'Pagada',
  'status.overdue': 'Vencida',
  'status.credited': 'Abonada',
  'app.loading': 'Cargando tu contabilidad…',
  'app.loadingPersonalFinance': 'Cargando tus finanzas personales…',
  'app.loadingEmployeePortal': 'Cargando tu portal del empleado…',
  'project.cost.field': 'Proyecto',
  'project.cost.none': 'Sin proyecto',
  'project.cost.billable': 'Refacturado al cliente',
  'project.cost.pickTitle': 'Elegir proyecto',
  'project.cost.search': 'Busca un proyecto o un cliente',
  'project.cost.searchEmpty': 'Ningún proyecto coincide con la búsqueda.',
  'project.cost.toProject': 'Ir al proyecto',
  'app.employeePortalVerifyTitle': 'Confirma tu correo electrónico',
  'app.employeePortalVerifyText': 'Hemos enviado un enlace de verificación a {{email}}. Puede tardar unos minutos en llegar. Revisa también la carpeta de spam. Abre el enlace para continuar.',
  'app.employeePortalVerifyResend': 'Reenviar el enlace',
  'app.employeePortalVerifySent': 'Se ha vuelto a enviar el enlace de verificación.',
  'app.employeePortalVerifyAlready': 'El correo electrónico ya está confirmado. Recarga la página.',
  'app.employeePortalVerifyFailed': 'No se pudo enviar el enlace de verificación.',
  'app.emailVerifyCheck': 'Ya lo he confirmado',
  'app.emailVerifyConfirmed': 'El correo electrónico está confirmado.',
  'app.emailVerifyNotConfirmed': 'El correo electrónico aún no está confirmado. Abre el enlace del correo e inténtalo de nuevo.',
  'app.emailVerifyCheckFailed': 'No se pudo comprobar el correo electrónico.',
  'app.emailVerifyInitialFailed': 'La cuenta se creó, pero no se pudo enviar el enlace de verificación. Prueba a enviarlo de nuevo.',
  'app.placeholder.title': 'Esta página llegará pronto',
  'app.placeholder.text': 'Estamos ultimando los detalles. ¡Vuelve pronto!',
  'app.nobusiness.title': '¿Con qué quieres empezar?',
  'app.nobusiness.text': 'Has iniciado sesión, pero todavía no tienes ninguna empresa en Plumme.',
  'app.nobusiness.create': 'Crear empresa',
  'app.nobusiness.signOut': 'Cerrar sesión',
  'common.signOut': 'Cerrar sesión',
  'auth.sub.default': 'Contabilidad sencilla para pequeñas empresas',
  'auth.sub.forgot': 'Restablece tu contraseña',
  'auth.sub.sent': 'Revisa tu correo',
  'auth.sub.signup': 'Crea una cuenta y configura tu empresa',
  'auth.language': 'Idioma',
  'auth.invite.household': 'Has recibido una invitación a las finanzas del hogar. Inicia sesión o crea una cuenta con el correo electrónico al que se envió la invitación.',
  'auth.invite.business': 'Has recibido una invitación de cliente. Introduce el correo electrónico al que se envió la invitación y la abriremos cuando inicies sesión.',
  'auth.email': 'Correo electrónico',
  'auth.emailPlaceholder': 'tu@ejemplo.com',
  'auth.password': 'Contraseña',
  'auth.name': 'Nombre',
  'auth.namePlaceholder': 'Tu nombre',
  'auth.passwordMin': 'Al menos 6 caracteres',
  'auth.showPassword': 'Mostrar contraseña',
  'auth.hidePassword': 'Ocultar contraseña',
  'auth.remember': 'Recordarme',
  'auth.forgot': '¿Olvidaste tu contraseña?',
  'auth.signIn': 'Iniciar sesión',
  'auth.signingIn': 'Iniciando sesión...',
  'auth.noAccount': '¿Aún no tienes cuenta?',
  'auth.createAccount': 'Crear cuenta',
  'auth.creating': 'Creando...',
  'auth.backToLogin': 'Volver a iniciar sesión',
  'auth.forgotCopy': 'Introduce el correo electrónico con el que inicias sesión y te enviaremos un enlace para crear una contraseña nueva.',
  'auth.sendResetLink': 'Enviar enlace de restablecimiento',
  'auth.sending': 'Enviando...',
  'auth.sentCopy': 'Hemos enviado un enlace a {email}. Sigue el enlace del correo para crear una contraseña nueva.',
  'auth.wrongEmail': '¿Correo equivocado? Inténtalo de nuevo',
  'auth.error.signIn': 'No se pudo iniciar sesión.',
  'auth.error.reset': 'No se pudo enviar el enlace de restablecimiento.',
  'auth.error.signUp': 'No se pudo crear la cuenta.',
  'capture.scan': 'Escanear justificante',
  'capture.toInbox': 'A la bandeja de entrada',
  'capture.toPurchase': 'A Compra pagada',
  'capture.analysisFailed': 'El justificante se subió, pero el análisis falló.',
  'capture.readyInPurchase': 'El justificante está listo en Compra pagada.',
  'capture.uploadingToInbox': 'Subiendo el justificante a la bandeja de entrada ...',
  'capture.uploadedToInbox': 'Justificante subido a la bandeja de entrada.',
  'capture.uploadFailed': 'No se pudo subir el justificante.',
  'capture.analysisTimedOut': 'El justificante se ha enviado. El análisis tarda un poco más y continúa en segundo plano.',
  'capture.paymentDialogLoadFailed': 'No se pudieron cargar las opciones de pago. Inténtalo de nuevo.',
  'nav.home': 'Inicio',
  'nav.aiBookkeeper': 'Contable IA',
  'nav.aiAdvisor': 'Asesor IA',
  'nav.newSale': 'Nueva venta',
  'nav.invoices': 'Facturas',
  'nav.otherSales': 'Otras ventas',
  'nav.customers': 'Clientes',
  'nav.products': 'Productos',
  'nav.projects': 'Proyectos',
  'nav.subscriptions': 'Contratos',
  'nav.newPurchase': 'Nueva compra',
  'nav.manualEntry': 'Asiento manual',
  'nav.suppliers': 'Proveedores',
  'nav.assets': 'Activos fijos',
  'nav.inventory': 'Inventario',
  'nav.inbox': 'Bandeja de entrada',
  'nav.incomeStatement': 'Cuenta de resultados',
  'nav.trialBalance': 'Balance de comprobación',
  'nav.budget': 'Presupuesto',
  'nav.filings': 'Declaración de IVA',
  'nav.taxReturn': 'Declaración de impuestos',
  'nav.yearEndClosing': 'Cierre del ejercicio',
  'nav.annualAccounts': 'Cuentas anuales',
  'nav.payroll': 'Nómina',
  'nav.mileageLog': 'Registro de kilometraje',
  'nav.vouchers': 'Transacciones',
  'nav.bank': 'Banco',
  'nav.myPage': 'Mi página',
  'nav.activityLog': 'Registro de actividad',
  'nav.altinn': 'Altinn',
  'nav.settings': 'Ajustes',
  'navgroup.sales': 'Ventas',
  'navgroup.purchases': 'Compras',
  'navgroup.reports': 'Informes',
  'navgroup.filings': 'Declaraciones',
  'navgroup.employees': 'Empleados',
  'navgroup.other': 'Otros',
  'navgroup.miscellaneous': 'Más',
  'navgroup.ai': 'IA',
  'navgroup.settings': 'Ajustes',
  'navhelp.home': 'Tu pantalla de inicio: cifras clave, gráficos y accesos directos para registrar ventas y compras.',
  'navhelp.aiBookkeeper': 'SuperPlumma revisa el banco, los justificantes, el IVA y los plazos, y te hace propuestas. Tú compruebas y apruebas antes de contabilizar nada.',
  'navhelp.aiAdvisor': 'Asesoramiento financiero de SuperPlumma: puntuación de salud, recomendaciones, previsión de tesorería, riesgos y optimización fiscal.',
  'navhelp.newSale': 'Crea una factura o un presupuesto nuevo para un cliente. La venta se contabiliza automáticamente.',
  'navhelp.invoices': 'Todas las facturas y presupuestos: estado, fechas de vencimiento y pago.',
  'navhelp.customers': 'Tu registro de clientes. Añade y edita los clientes a los que facturas.',
  'navhelp.products': 'Los bienes y servicios que vendes, con precio y tipo de IVA, listos para usar en las facturas.',
  'navhelp.projects': 'Registra horas en proyectos y actividades, sigue lo que se ha hecho y convierte las horas sin facturar en borradores de factura.',
  'navhelp.subscriptions': 'Suscripciones, facturas recurrentes y listas de clientes con control del envío automático.',
  'navhelp.newPurchase': 'Registra una compra o una factura de proveedor con justificante, proveedor, importe y cuenta.',
  'navhelp.manualEntry': 'Contabiliza manualmente directo en una cuenta cuando necesites control total del asiento.',
  'navhelp.suppliers': 'Tu registro de proveedores: nombre, número de empresa y cuenta bancaria para los pagos.',
  'navhelp.assets': 'Activos fijos y bienes duraderos que se amortizan con el tiempo.',
  'navhelp.inventory': 'Recuentos de existencias y valor de tu inventario. Documenta el recuento y contabiliza la variación de existencias.',
  'navhelp.inbox': 'Recibos que han llegado pero aún no están contabilizados. Arrástralos al asiento correcto.',
  'navhelp.incomeStatement': 'Ingresos menos gastos: muestra si el negocio es rentable.',
  'navhelp.trialBalance': 'El saldo de cada cuenta: la base de tus informes financieros.',
  'navhelp.budget': 'Crea un presupuesto y comprueba cómo vas respecto a tus objetivos.',
  'navhelp.filings': 'Comprueba la base de IVA de cada periodo. La declaración en sí se presenta ante Skatteetaten.',
  'navhelp.taxReturn': 'Borrador de la declaración de impuestos basado en tu contabilidad: comprueba las cifras antes de presentarla ante Skatteetaten.',
  'navhelp.yearEndClosing': 'Paso a paso por todo lo necesario para cerrar el ejercicio fiscal.',
  'navhelp.annualAccounts': 'Cuenta de resultados, balance, notas y firma. Las cuentas anuales se presentan ante Regnskapsregisteret fuera de Plumme.',
  'navhelp.payroll': 'Ejecuta la nómina, crea las hojas de salario y contabiliza la nómina. La a-melding se presenta fuera de Plumme.',
  'navhelp.mileageLog': 'Registra los trayectos de trabajo y consulta los kilómetros y las deducciones del año.',
  'navhelp.vouchers': 'Resumen completo de las transacciones contabilizadas y sus justificantes: búscalas y encuéntralas de nuevo.',
  'navhelp.bank': 'Sube extractos bancarios y concilia las cuentas bancarias con tu contabilidad.',
  'navhelp.myPage': 'Tu perfil y tus ajustes de usuario.',
  'navhelp.activityLog': 'Historial completo de lo que se ha hecho en la contabilidad y quién lo ha hecho.',
  'navhelp.altinn': 'Acceso directo a las declaraciones y mensajes en Altinn.',
  'navhelp.settings': 'Ajustes de la empresa, la contabilidad y la aplicación.',
  'navhelp.fallback': 'Abrir {label}.',
  'route.home': 'Inicio',
  'route.newSale': 'Nueva venta',
  'route.newSaleliste': 'Facturas',
  'route.customers': 'Clientes',
  'route.products': 'Productos',
  'route.projects': 'Proyectos',
  'route.aiBookkeeper': 'Contable IA',
  'route.aiAdvisor': 'Asesor IA',
  'route.newPurchase': 'Compra pagada',
  'route.manualEntry': 'Asiento manual',
  'route.vouchers': 'Transacciones',
  'route.suppliers': 'Proveedores',
  'route.assets': 'Activos fijos',
  'route.filings': 'Declaraciones',
  'route.inbox': 'Bandeja de entrada',
  'route.documentation': 'Documentación',
  'route.mileageLog': 'Registro de kilometraje',
  'route.bank': 'Banco',
  'route.altinn': 'Altinn',
  'route.settings': 'Ajustes',
  'route.otherSales': 'Otras ventas',
  'route.subscriptions': 'Contratos',
  'route.incomeStatement': 'Cuenta de resultados',
  'route.trialBalance': 'Balance de comprobación',
  'route.budget': 'Presupuesto',
  'route.payroll': 'Nómina',
  'route.taxReturn': 'Declaración de impuestos',
  'route.yearEndClosing': 'Cierre del ejercicio',
  'route.annualAccounts': 'Cuentas anuales',
  'route.myPage': 'Mi página',
  'route.employeePortal': 'Portal del empleado',
  'route.activityLog': 'Registro de actividad',
  'route.personalFinance': 'Finanzas personales',
  'shell.openMenu': 'Abrir menú',
  'shell.closeMenu': 'Cerrar menú',
  'shell.collapseMenu': 'Contraer menú',
  'shell.showLabels': 'Mostrar etiquetas del menú',
  'shell.hideLabels': 'Ocultar etiquetas del menú',
  'shell.designSystem': 'Sistema de diseño ↗',
  'shell.customizeMenu': 'Personalizar menú',
  'shell.customizeHelpTitle': 'Personalizar menú',
  'shell.customizeHelp': 'Elige qué páginas aparecen en el menú lateral. Oculta las que no uses para mantener el menú ordenado.',
  'shell.customizeTitle': 'Personalizar el menú lateral',
  'shell.customizeVisible': '{visible} de {total} visibles',
  'shell.customizeLead': 'Desactiva las páginas que no uses y desaparecerán del menú lateral. Puedes volver a activarlas cuando quieras.',
  'shell.customizeAllPages': 'Todas las páginas',
  'shell.customizeAiMode': 'Modo IA',
  'shell.customizeAlwaysOn': 'Siempre activado',
  'shell.customizeDone': 'Listo',
  'shell.camCapture': 'Fotografiar un documento',
  'shell.camHelp': 'Haz una foto de un documento con la cámara y cárgala directamente en la bandeja de entrada o como una compra nueva.',
  'shell.moreOptions': 'Más opciones',
  'shell.search': 'Buscar',
  'shell.searchAll': 'Buscar en todo',
  'shell.searchHelp': 'Busca en la empresa activa: clientes, facturas, productos, justificantes, proyectos, páginas y ayuda. Toca para abrir la búsqueda (atajo: Ctrl/⌘+K).',
  'shell.searchPlaceholderLong': 'Buscar en todo: facturas, clientes, justificantes…',
  'shell.searchEnterHint': 'para ver todas las coincidencias',
  'shell.companyHelpTitle': 'Elegir empresa o empleador',
  'shell.companyHelp': 'Cambia entre las contabilidades que llevas y los empleadores para los que trabajas. Todo lo que ves en la aplicación se refiere a la empresa seleccionada.',
  'shell.yearHelpTitle': 'Ejercicio fiscal',
  'shell.yearHelp': 'Elige el ejercicio fiscal en el que estás trabajando. Todas las cifras y declaraciones se refieren al año seleccionado.',
  'shell.theme.helpTitle': 'Tema claro / oscuro',
  'shell.theme.help': 'Cambia entre un aspecto claro y oscuro en toda la aplicación. Tu elección se recuerda.',
  'shell.theme.toLight': 'Cambiar al tema claro',
  'shell.theme.toDark': 'Cambiar al tema oscuro',
  'shell.theme.light': 'Tema claro',
  'shell.theme.dark': 'Tema oscuro',
  'shell.bg.label': 'Color de fondo',
  'shell.bg.title': 'Color de fondo de esta página',
  'shell.bg.help': 'Elige el color de fondo solo para esta página. El color se guarda por página.',
  'shell.bg.menuTitle': 'Color de fondo · esta página',
  'shell.bg.default': 'Ciruela',
  'shell.bg.mint': 'Menta',
  'shell.bg.varm': 'Cálido',
  'shell.bg.sky': 'Azul',
  'shell.bg.rose': 'Rosa',
  'shell.bg.skog': 'Bosque',
  'skin.title': 'Apariencia',
  'skin.standard': 'Estándar',
  'skin.standardSub': 'Plumme',
  'skin.klassisk': 'Clásico',
  'skin.klassiskSub': 'Sobrio',
  'shell.client.employers': 'Tus empleadores',
  'shell.client.employer': 'Empleador',
  'shell.client.employee': 'Empleado',
  'shell.client.private': 'Personal',
  'shell.client.firm': 'Despacho contable',
  'shell.client.firmSub': 'Vista de clientes y conciliación',
  'rf.firm': 'Despacho contable',
  'rf.role.owner': 'Propietario',
  'rf.role.admin': 'Administrador',
  'rf.role.employee': 'Miembro del equipo',
  'rf.group.firm': 'Contable',
  'rf.group.team': 'Chat del equipo',
  'rf.group.other': 'Otros',
  'rf.nav.clients': 'Vista general de clientes',
  'rf.nav.reconciliation': 'Conciliación',
  'rf.nav.control': 'Control',
  'rf.nav.teamchat': 'Chat del equipo',
  'rf.nav.members': 'Equipo',
  'rf.nav.clientList': 'Clientes',
  'rf.client.pageBody': 'Conecta el despacho con sus clientes y asigna compañeros a los encargos.',
  'rf.client.addTitle': 'Conectar un cliente',
  'rf.client.addBody': 'El cliente necesita una cuenta de Plumme para su empresa. El despacho solo obtiene acceso cuando el cliente acepta.',
  'rf.client.billedTo': 'Quién paga',
  'rf.client.billedToClient': 'El cliente paga',
  'rf.client.billedToFirm': 'El despacho paga',
  'rf.client.request': 'Enviar solicitud',
  'rf.client.requesting': 'Enviando …',
  'rf.client.requested': 'La solicitud se envió al cliente',
  'rf.avst.noClient': 'Elige primero un cliente',
  'rf.avst.allClients': 'Todos los clientes',
  'rf.avst.thisClient': 'Este cliente',
  'rf.avst.noClientBody': 'La conciliación abarca un cliente a la vez. Abre un cliente desde la vista general de clientes y la carpeta de conciliación lo seguirá.',
  'rf.client.requestedMailFailed': 'La solicitud se envió, pero no se pudo entregar la notificación por correo. El cliente la verá en su próximo inicio de sesión.',
  'rf.client.requestedNoRecipient': 'La solicitud se envió, pero la empresa no tiene ningún propietario ni administrador a quien notificar. Ponte en contacto con el cliente directamente.',
  'rf.client.noneTitle': 'Aún no hay clientes',
  'rf.client.noneBody': 'Conecta el despacho con un cliente usando su número de organización. El cliente debe aprobarlo antes de que obtengas acceso.',
  'rf.client.pendingBody': 'El cliente debe aceptar la solicitud en su propia cuenta de Plumme. Nadie del despacho tiene acceso hasta entonces.',
  'rf.client.assignWho': 'Asignar al encargo',
  'rf.client.assignPick': 'Elige un compañero',
  'rf.client.assignRole': 'Rol en el encargo',
  'rf.client.assign': 'Asignar',
  'rf.client.assigned': 'El compañero se asignó al cliente',
  'rf.client.end': 'Finalizar el encargo',
  'rf.client.ended': 'El encargo ha finalizado',
  'rf.client.endConfirm': '¿Finalizar el encargo de {name}? El acceso que el despacho concedió a sus compañeros se retira al mismo tiempo.',
  'fe.title': 'Un despacho contable solicita acceso',
  'fe.theFirm': 'El despacho',
  'fe.body': 'Si aceptas, los compañeros que el despacho asigne al encargo tendrán acceso a tu contabilidad. Puedes poner fin al acuerdo en cualquier momento.',
  'fe.billedToFirm': 'El despacho paga la suscripción',
  'fe.billedToClient': 'Tú pagas la suscripción',
  'fe.accept': 'Conceder acceso',
  'fe.accepting': 'Aceptando …',
  'fe.accepted': '{firm} ya tiene acceso a tu contabilidad.',
  'fe.decline': 'Rechazar',
  'fe.declined': 'La solicitud fue rechazada.',
  'fi.title': 'Te han invitado como compañero',
  'fi.theFirm': 'el despacho',
  'fi.body': 'La invitación te da acceso al propio despacho. El acceso a un cliente concreto solo llega cuando el despacho te asigne a un encargo.',
  'fi.verifyFirst': 'Confirma primero tu correo electrónico. Te hemos enviado un nuevo enlace de confirmación.',
  'fi.accept': 'Unirse',
  'fi.accepting': 'Uniéndose …',
  'fi.accepted': 'Ahora eres compañero en {firm}.',
  'fi.acceptFailed': 'No se pudo aceptar la invitación.',
});
